const DocumentTypes = Object.freeze({
  StudentEvaluation: 1,
  MinuteReferralEvaluationAt: 13,
  MinutaDiscussionSigned: 16,
  EvaluationReportSigned: 17,
  Minuta: 20,
  Otro: 21,
  CopiaDeQuerella: 22,
  ReferralServiceAT: 23,
  PreviousEvaluationAT: 24,
  LocationRejectedDocument: 26,
  MinuteControversy: 28,
  MinutaResolucionControversia: 29,
  CertTarea15ManualEEMadrePadre: 210,
  PropuestaServicios: 209,
  CertificacionVisita: 165,
  //Intervetions Plans
  PlanDeIntervencion: 83,
  PaquetePlanAnual: 84,
  PlanDeEnmienda: 85,
  ResumenResultadoDeServicios: 86, //No existe :(
  JustificacionAusencia: 88,
  ServiceProposalFacilitator: 191,
  ServiceProposalDirector: 196,
  ServiceProposalCentralLevel: 209,
  ServiceProposal: 219,
  PaymentCertificate: 1541,
  EvidencePaymentReceipt: 1542,
  Other: 1543,
  ReimbursementCertification: 1550,
  SignedAdmissionNote: 1580,
  OtherProviderProposal: 1608,
  CartaAprobacionReembolso: 1624,
  EnmiendaDeContrato: 1625,
  OtherPurchaseServiceSupportingDocument: 1629,
  OriginalCopyPurchaseServiceSupportingDocument: 1631,
  CostEstimate: 1640,
});

export default DocumentTypes;
